import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-finishing-office',
  templateUrl: './finishing-office.component.html',
  styleUrls: ['./finishing-office.component.css']
})
export class FinishingOfficeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/finishing/finishing-office/finishing-office.component.ts